<div
  class="container"
  fxLayout="row wrap"
  fxLayoutGap="2%"
  fxLayout.lt-md="column"
  matomoForm="incoming-transactions-filter"
>
  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.PAYER_ID" | translate }}</mat-label>
    <input
      matInput
      [formControl]="payerPartyId"
      matomoClick="filter-input-focus"
      category="Filter Interaction"
      name="Payer Id"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.EXTERNAL_ID" | translate }}</mat-label>
    <input
      matInput
      [formControl]="externalId"
      matomoClick="filter-input-focus"
      category="Filter Interaction"
      name="External Id"
    />
  </mat-form-field>

  <!-- <mat-form-field fxFlex="20%">
    <mat-label>Payer DFSP name</mat-label>
    <input matInput [formControl]="payerDfspName" [matAutocomplete]="dfspEntriesAutocomplete">
  </mat-form-field> -->

  <mat-form-field fxFlex="20%">
    <mat-label>{{
      "TRANSACTIONS.AMS_BUSINESS_SHORT_CODE" | translate
    }}</mat-label>
    <mat-select
      [formControl]="payerDfspId"
      matomoClick="filter-select-open"
      category="Filter Interaction"
      name="AMS Business Short Code"
    >
      <mat-option
        *ngFor="let code of amsCodes"
        [value]="code.value"
        matomoClick="filter-option-select"
        category="Filter Selection"
        [name]="'AMS Code: ' + code.option"
      >
        {{ code.option }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.PAYEE_ID" | translate }}</mat-label>
    <input
      matInput
      [formControl]="payeePartyId"
      matomoClick="filter-input-focus"
      category="Filter Interaction"
      name="Payee Id"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.TRANSACTION_ID" | translate }}</mat-label>
    <input
      matInput
      [formControl]="transactionId"
      matomoClick="filter-input-focus"
      category="Filter Interaction"
      name="Transaction ID"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.STATUS" | translate }}</mat-label>
    <mat-select
      [formControl]="status"
      matomoClick="filter-select-open"
      category="Filter Interaction"
      name="Transaction Status"
    >
      <mat-option
        [value]=""
        matomoClick="filter-option-select"
        category="Filter Selection"
        name="Status: All"
      >
        {{ "TRANSACTIONS.SELECT_STATUS" | translate }}
      </mat-option>
      <ng-container *ngFor="let filter of transactionStatusData">
        <mat-option
          [value]="filter.value"
          *ngIf="!filter.hidden"
          matomoClick="filter-option-select"
          category="Filter Selection"
          [name]="'Status: ' + filter.option"
        >
          {{ filter.option }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.AMOUNT" | translate }}</mat-label>
    <input
      matInput
      [formControl]="amount"
      matomoClick="filter-input-focus"
      category="Filter Interaction"
      name="Amount"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.CURRENCY" | translate }}</mat-label>
    <input
      matInput
      [formControl]="currencyCode"
      [matAutocomplete]="currenciesAutocomplete"
      matomoClick="filter-input-focus"
      category="Filter Interaction"
      name="Currency Code"
    />
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{
      "TRANSACTIONS.TRANSACTION_DATE_FROM" | translate
    }}</mat-label>
    <input
      matInput
      [ngxMatDatetimePicker]="transactionDateFromPicker"
      placeholder="{{ 'TRANSACTIONS.CHOOSE_DATE' | translate }}"
      [formControl]="transactionDateFrom"
      [min]="minDate"
      [max]="maxDate"
      matomoClick="filter-date-focus"
      category="Filter Interaction"
      name="Transaction Date From"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="transactionDateFromPicker"
      matomoClick="date-picker-toggle"
      category="Filter Interaction"
      name="Date Picker From"
    ></mat-datepicker-toggle>
    <ngx-mat-datetime-picker
      #transactionDateFromPicker
      [showSpinners]="true"
      [showSeconds]="true"
      [stepHour]="1"
      [stepMinute]="1"
      [stepSecond]="1"
    >
    </ngx-mat-datetime-picker>
  </mat-form-field>

  <mat-form-field fxFlex="20%">
    <mat-label>{{ "TRANSACTIONS.TRANSACTION_DATE_TO" | translate }}</mat-label>
    <input
      matInput
      [ngxMatDatetimePicker]="transactionDateToPicker"
      placeholder="{{ 'TRANSACTIONS.CHOOSE_DATE' | translate }}"
      [formControl]="transactionDateTo"
      [min]="minDate"
      [max]="maxDate"
      matomoClick="filter-date-focus"
      category="Filter Interaction"
      name="Transaction Date To"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="transactionDateToPicker"
      matomoClick="date-picker-toggle"
      category="Filter Interaction"
      name="Date Picker To"
    ></mat-datepicker-toggle>
    <ngx-mat-datetime-picker
      #transactionDateToPicker
      [showSpinners]="true"
      [showSeconds]="true"
      [stepHour]="1"
      [stepMinute]="1"
      [stepSecond]="1"
    >
    </ngx-mat-datetime-picker>
  </mat-form-field>
</div>

<!-- Autocomplete data -->
<mat-autocomplete
  autoActiveFirstOption
  #currenciesAutocomplete="matAutocomplete"
  [displayWith]="displayCurrencyName"
>
  <mat-option
    *ngFor="let currency of filteredCurrencies | async"
    [value]="{
      AlphabeticCode: currency.AlphabeticCode,
      Currency: currency.Currency
    }"
    matomoClick="autocomplete-option-select"
    category="Filter Selection"
    [name]="
      'Currency: ' + currency.Currency + ' (' + currency.AlphabeticCode + ')'
    "
  >
    {{ currency.Currency }} ( {{ currency.AlphabeticCode }} )
  </mat-option>
</mat-autocomplete>

<mat-autocomplete
  autoActiveFirstOption
  #dfspEntriesAutocomplete="matAutocomplete"
  [displayWith]="displayDfspName"
>
  <mat-option
    *ngFor="let entry of filteredDfspEntries | async"
    [value]="{ id: entry.id, name: entry.name }"
    matomoClick="autocomplete-option-select"
    category="Filter Selection"
    [name]="'DFSP: ' + entry.name + ' (' + entry.id + ')'"
  >
    {{ entry.name }} ( {{ entry.id }} )
  </mat-option>
</mat-autocomplete>

<div class="mat-elevation-z8 container">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="startedAt">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="table-header-sort"
        category="Table Interaction"
        name="Sort by Start Time"
      >
        {{ "TRANSACTIONS.START_TIME_UTC" | translate }}
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ formatDate(convertTimestampToUTCDate(transaction.startedAt)) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="completedAt">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="table-header-sort"
        category="Table Interaction"
        name="Sort by Completed Time"
      >
        {{ "TRANSACTIONS.COMPLETED_TIME_UTC" | translate }}
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ formatDate(convertTimestampToUTCDate(transaction.completedAt)) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="transactionId">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="table-header-sort"
        category="Table Interaction"
        name="Sort by Transaction ID"
      >
        {{ "TRANSACTIONS.TRANSACTION_ID" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let transaction"
        matTooltip="{{ transaction.transactionId }}"
      >
        {{ shortenValue(transaction.transactionId) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="payerPartyId">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="table-header-sort"
        category="Table Interaction"
        name="Sort by Payer ID"
      >
        {{ "TRANSACTIONS.PAYER_ID" | translate }}
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.payerPartyId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="payerDfspId">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="table-header-sort"
        category="Table Interaction"
        name="Sort by AMS Business Short Code"
      >
        {{ "TRANSACTIONS.AMS_BUSINESS_SHORT_CODE" | translate }}
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.payerDfspId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="payerDfspName">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="table-header-sort"
        category="Table Interaction"
        name="Sort by Payer DFSP Name"
      >
        {{ "TRANSACTIONS.PAYER_DFSP_NAME" | translate }}
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ displayDfspName(getDfpsEntry(transaction.payerDfspId)) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="payeePartyId">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="table-header-sort"
        category="Table Interaction"
        name="Sort by Payee ID"
      >
        {{ "TRANSACTIONS.PAYEE_ID" | translate }}
      </th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.payeePartyId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="table-header-sort"
        category="Table Interaction"
        name="Sort by Amount"
      >
        {{ "TRANSACTIONS.AMOUNT" | translate }}
      </th>
      <td mat-cell *matCellDef="let transaction">{{ transaction.amount }}</td>
    </ng-container>

    <ng-container matColumnDef="currency">
      <th mat-header-cell *matHeaderCellDef>
        {{ "TRANSACTIONS.CURRENCY" | translate }}
      </th>
      <td mat-cell *matCellDef="let transaction">{{ transaction.currency }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        matomoClick="table-header-sort"
        category="Table Interaction"
        name="Sort by Status"
      >
        {{ "TRANSACTIONS.STATUS" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let transaction"
        [ngClass]="{
          red: transaction.status === 'FAILED',
          green: transaction.status === 'COMPLETED',
          orange: transaction.status === 'ACTION_NEEDED'
        }"
      >
        {{ transaction.status }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td
        mat-cell
        *matCellDef="let transaction"
        (click)="$event.stopPropagation()"
      >
        <div *ngIf="transaction.status === 'ACTION_NEEDED'">
          <button
            mat-button
            color="primary"
            (click)="
              openRetryResolveDialog(transaction.workflowInstanceKey, 'retry')
            "
            matomoClick="transaction-action-retry"
            category="Transaction Action"
            name="Retry Transaction"
          >
            <fa-icon icon="redo" size="lg"></fa-icon>
          </button>
          <button
            mat-button
            class="green"
            (click)="
              openRetryResolveDialog(transaction.workflowInstanceKey, 'resolve')
            "
            matomoClick="transaction-action-resolve"
            category="Transaction Action"
            name="Resolve Transaction"
          >
            <fa-icon icon="check" size="lg"></fa-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="feeMethod">
      <th mat-header-cell *matHeaderCellDef> Fee method </th>
      <td mat-cell *matCellDef="let transaction"> {{ transaction.feeMethod }} </td>
    </ng-container>

    <ng-container matColumnDef="feeAmount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Fee </th>
      <td mat-cell *matCellDef="let transaction"> {{ transaction.payerFee+transaction.payeeFee }} </td>
    </ng-container> -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [routerLink]="['view', row.workflowInstanceKey]"
      class="select-row"
      matomoClick="transaction-row-click"
      category="Navigation"
      [name]="'View Transaction: ' + row.transactionId"
    ></tr>
  </table>

  <mat-paginator
    [length]="dataSource?.records$ | async"
    [pageSize]="10"
    [pageSizeOptions]="[10, 25, 50, 100]"
    showFirstLastButtons="false"
    matomoClick="paginator-interaction"
    category="Table Navigation"
    name="Page Navigation"
  ></mat-paginator>
</div>
